import { LogoSpotify, cssColorValue, screenMdMin, semanticColors, TextLink } from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';

const StyledLogo = styled(LogoSpotify)`
  color: ${cssColorValue(semanticColors.textBase)};
  fill: ${cssColorValue(semanticColors.textBase)};
  height: 26px;
  @media (min-width: ${screenMdMin}) {
    height: 36px;
  }
`;

const LinkWrapper = styled(TextLink)`
  && {
    text-decoration: none;

    &:focus {
      box-shadow: none;
      transition: none;
      outline: 5px auto -webkit-focus-ring-color;
    }
  }

  @media (min-width: ${screenMdMin}) {
    flex: 0 1 15%;
  }
`;

export const FooterLogo = () => {
  return (
    <LinkWrapper href="https://www.spotify.com" data-testid="footer-logo">
      <StyledLogo />
    </LinkWrapper>
  );
};
